<template>
  <v-data-table
    :headers="headers"
    :items="tasks"
    :loading="loading"
    loading-text=""
    :items-per-page-text="$t('tables.RowsPerPage')"
    :items-per-page-items="[5, 10, 25, { text: $t('All'), value: -1 }]"
    :header-props="{ sortIcon: 'mdi-menu-down' }"
    :footer-props="{ prevIcon: 'mdi-menu-left', nextIcon: 'mdi-menu-right' }"
    class="mt-3 mb-2 elevation-2"
  >
    <template v-slot:item="props">
      <tr @click="openTask(props.item)">
        <td>
          <activity-task-status-icon
            :status="props.item.state"
            :delayed="isDelayed(props.item)"
          />
        </td>

        <!--<td>{{ showDependencies(props.item) }}</td>-->

        <td>{{ props.item.title }}</td>

        <td>{{ getUserName(props.item.user_assignee_id) }}</td>

        <td>{{ getFormattedDate(props.item.scheduled_date) }}</td>
      </tr>
    </template>
  </v-data-table>
</template>

<script>
import { activitiesTasksDataMixin } from "@/mixins/field/activitiesTasksDataMixin";
import ActivityTaskStatusIcon from "../../../../../FieldManagement/StatusIcon";

export default {
  name: "ObjectFormActivityDetailsTasksTable",

  components: { ActivityTaskStatusIcon },

  mixins: [activitiesTasksDataMixin],

  /**
   * received tasks from request
   */
  props: {
    tasks: Array
  },

  data() {
    return {
      loading: false
    };
  },

  computed: {
    headers() {
      return [
        {
          text: this.$i18n.t("State"),
          align: "left",
          value: "state",
          width: "10%"
        },
        /*{
          text: this.$i18n.tc("Dependency", 2),
          value: "dependencies",
          width: "10%"
        },*/
        { text: this.$i18n.tc("Task", 1), value: "title", width: "50%" },
        {
          text: this.$i18n.tc("Assignee", 1),
          value: "user_assignee_id",
          width: "15%"
        },
        {
          text: this.$i18n.t("ScheduledFor"),
          value: "scheduled_date",
          width: "15%"
        }
      ];
    }
  },
  mounted() {
    /**
     * loads all users to be available in the table
     */
    this.loadAllUsers();
  },

  methods: {
    /**
     * opens task
     */
    openTask(task) {
      this.$emit("openTask", task.uuid);
    },

    isDelayed(task) {
      if (!task.scheduled_date || task.state === "completed") {
        return false;
      } else {
        let scheduledDate = Date.parse(task.scheduled_date);
        return task.status !== "closed" && new Date() > scheduledDate;
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Home/Forms/_SpecialTabs/Activities/ActivityDetails/ActivityDetailsTasks.vue